import { render, staticRenderFns } from "./alert-guideline-modal.vue?vue&type=template&id=6c1f73b7&scoped=true&"
import script from "./alert-guideline-modal.vue?vue&type=script&lang=ts&"
export * from "./alert-guideline-modal.vue?vue&type=script&lang=ts&"
import style0 from "./alert-guideline-modal.vue?vue&type=style&index=0&id=6c1f73b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1f73b7",
  null
  
)

export default component.exports